import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { setCategory } from "./store/slices/dropdownSlice";
import "./Dropdown.css";

export default function Dropdown() {
  const dispatch = useDispatch();

  const handleCategoryChange = (categoryValue) => {
    dispatch(setCategory(categoryValue));
  };

  const categories = [
     {
      name: "Hamper Packages",
      image: "/thedata/WeddingHampers.png",
    },
    {
      name: "Kashmiri Dry Fruits",
      image: "/thedata/kashmiridryfruits.png",
    },
    {
      name: "Dry Fruits & Nuts",
      image: "/thedata/DryFriutsAndNuts.png",
    },
    {
      name: "Honey & Saffron",
      image: "/thedata/KashmiriHoneyAndSaffron.png",
    },
    {
      name: "Dates",
      image: "/thedata/Dates.png",
    },
    {
      name: "Stuffed Dates",
      image: "/thedata/StuffedDates.png",
    },
    {
      name: "Seeds",
      image: "/thedata/Seeds.png",
    },
    {
      name: "Kashmiri Fine Baskets",
      image: "/thedata/KashmiriFineBaskets.png",
    },
   
  ];

  return (
    <div className="dropdown-container">
      <h2 className="dropdown-title">Shop Our Range</h2>
      <div className="category-grid">
       {categories.map((category) => (
  category.name === "Stuffed Dates" ? (
    <div key={category.name} className="category-item coming-soon">
      <img
        src={category.image}
        alt={category.name}
        className="category-image"
      />
      <span className="category-name">{category.name}</span>
      <span className="coming-soon-text">Coming Soon</span>
    </div>
  ) : (
    <Link
      key={category.name}
      to="/category"
      className="category-item"
      onClick={() => handleCategoryChange(category.name)}
    >
      <img
        src={category.image}
        alt={category.name}
        className="category-image"
      />
      <span className="category-name">{category.name}</span>
    </Link>
  )
))}

      </div>
    </div>
  );
}
